import { connect } from 'react-redux'
import ConnectProfile from './connect-provider'
import difference from 'lodash/difference'
import {
  getFlatProviders,
  getConnectProviderRequest
} from '../../../../../stores/providers/providers.selectors'
import { connectProvider } from '../../../../../stores/providers/providers.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const providers = ['facebook', 'google', 'twitter', 'o365']

const mapStateToProps = state => ({
  providers: difference(providers, getFlatProviders(state)),
  pending: getConnectProviderRequest(state).pending
})

const mapDispatchToProps = dispatch => ({
  onConnect: connectFn =>
    dispatch(connectProvider(connectFn)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectProfile)
